import { render, staticRenderFns } from "./ScheduleForm.vue?vue&type=template&id=580b0bf0&"
import script from "./ScheduleForm.vue?vue&type=script&lang=js&"
export * from "./ScheduleForm.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleForm.vue?vue&type=style&index=0&id=580b0bf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports